
import { useState, useRef, useEffect} from "react"
import "./LanguageDropdown.css"
import problemsJSON from "../../../Data/Problems.json"
import { getStringLanguageNameByLanguageID } from "../../../Data/ProblemsMethod"


export default function LanguageDropdown({problemID, validLanguage, selectedLanguage, setSelectedLanguage}){


    const [language_dropdown_selected, set_language_dropdown_selected] = useState(false)
    const all_languages = [ "C++", "Java", "Python", "C", "Scala", "JavaScript", "Bash", "Rust", "x86", "Verilog"];

    const currProblem = problemsJSON.find(problem => problem.problem_id === problemID);
    
    const problem_languages = currProblem.language_ids.map((langID => getStringLanguageNameByLanguageID(langID)))





    const left_languages = all_languages.slice(0,5).map((language) =>(
        <div className={problem_languages.includes(language) ? "language-option" : "language-option-not-available"}> 
            <div 
                className={problem_languages.includes(language) ? "language-text" : "language-text-not-available"}
                onClick={(e) => {
                    console.log("Language in dropdown: ", getStringLanguageNameByLanguageID(language) )
                    setSelectedLanguage(getStringLanguageNameByLanguageID(language));
                    console.log("Language in dropdown: ", getStringLanguageNameByLanguageID(language) )
                    set_language_dropdown_selected(false);
                    sessionStorage.setItem(problemID, getStringLanguageNameByLanguageID(language)); 
                  }}
            > 
                {language}
            </div>
        </div>
    ));
    const right_languages = all_languages.slice(5,10).map((language) =>(
        <div className={problem_languages.includes(language) ? "language-option" : "language-option-not-available"}> 
            <div
                className={problem_languages.includes(language) ? "language-text" : "language-text-not-available"}
                onClick={(e) => {
                    setSelectedLanguage(getStringLanguageNameByLanguageID(language));
                    set_language_dropdown_selected(false);
                    sessionStorage.setItem(problemID, getStringLanguageNameByLanguageID(language)); 
                }}
            > 
                {language}
            </div>
        </div>
    ));


    
    //When component mounts check if there is a selection language stored in session
    useEffect(() =>{
        const sessionLang = sessionStorage.getItem(problemID);
        if(sessionLang !== null){
            setSelectedLanguage(Number(sessionLang))
        }
    },[])

    const LanguageDropdownRef = useRef(null)
    useEffect(() => {

        const handleClickOutside = (event) => {
            // Check that the ref is not not null (redundant)
            // Then make sure we are not selecting the button itself
            if (LanguageDropdownRef.current && !LanguageDropdownRef.current.contains(event.target)) {
                set_language_dropdown_selected(false);
            }
        };

        window.addEventListener("click", handleClickOutside);

        return () => {
            window.removeEventListener("click", handleClickOutside);
        };

    }, []);



    return(
        <>


        <div  ref={LanguageDropdownRef}>
            <button className="language-options-wrapper"
                onClick={() => set_language_dropdown_selected(!language_dropdown_selected)}
            >
                <div className="current-language">
                    <div className="language-and-arrow-wrapper">
                        {getStringLanguageNameByLanguageID(selectedLanguage)}

                        {!language_dropdown_selected ? <i className="arrow up"/>:<i className="arrow down"/>}
                    </div>
                </div>
            </button>
            {
            language_dropdown_selected && 
            <div className="language-dropdown" >
                <div className="left-languages">
                    {left_languages}
                </div>
                <hr style={{ width: '1px', height: '90%', margin: 'auto auto', backgroundColor: '#4e4e4e', border: 'none'}} />
                <div className="right-languages">
                    {right_languages}
                </div>
            </div>
            }
        </div>
           
        </> 
    )
}